import { useEffect } from 'react'
import { useLocation, useNavigationType } from 'react-router-dom'

export const ScrollToTop = () => {
  const { pathname } = useLocation()
  const navType = useNavigationType()

  useEffect(() => {
    if (navType === 'POP') {
      return
    }

    window.scrollTo({ top: 0, behavior: 'instant' })
    document.documentElement.scrollTop = 0
    document.body.scrollTop = 0
  }, [pathname, navType])

  return null
}